// Private Route 컴포넌트 - 로그인 검증
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import { Flex, Spinner, Text } from '@chakra-ui/react';

const PrivateRoute = ({ component: Component, adminOnly, userOnly, scheduleOnly, ...rest }) => {
  const { currentUser, userProfile, loading } = useAuth();

  // 로딩 중
  if (loading) {
    return (
      <Flex 
        direction="column" 
        align="center" 
        justify="center" 
        minH="100vh"
        gap={4}
      >
        <Spinner size="xl" color="blue.500" thickness="4px" />
        <Text fontSize="lg" color="gray.600">로딩 중...</Text>
      </Flex>
    );
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        // 로그인 안되어 있으면 로그인 페이지로
        if (!currentUser) {
          return <Redirect to="/auth/signin" />;
        }

        // 관리자 전용 페이지인데 권한 없으면 대시보드로
        if (adminOnly && userProfile?.role !== 'admin' && userProfile?.role !== 'manager') {
          return <Redirect to="/admin/dashboard" />;
        }

        // 일반 회원 전용 페이지인데 관리자이면 대시보드로
        if (userOnly && (userProfile?.role === 'admin' || userProfile?.role === 'manager')) {
          return <Redirect to="/admin/dashboard" />;
        }

        // 스케줄 권한 필요한 페이지인데 권한 없으면 대시보드로
        if (scheduleOnly && !userProfile?.canUseSchedule && userProfile?.role !== 'admin' && userProfile?.role !== 'manager') {
          return <Redirect to="/admin/dashboard" />;
        }

        // 통과
        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;

